import React from 'react';
import { Badges } from '../../components';
import classNames from 'classnames';

import css from './ProfilePage.module.css';
import { capitalizeFirstLetter, getUserTier } from '../../util/data';

const infoItem = (infoName, infoValue) => (
  <div className={css.infoItem}>
    <span className={css.infoName}>{infoName}</span>
    <span className={css.infoValue}>{infoValue}</span>
  </div>
);

const SectionInfo = props => {
  const { intl, user, currentUser, userReviews, userComments, isBetaMode } = props;

  const { metadata } = user.attributes.profile;
  const userPoints = metadata?.points ? Math.floor(metadata.points) : 0;
  const userSubscriptions = metadata?.memberships ? metadata.memberships.length : 0;
  // Who someone follows is private: the count shows on your own profile only.
  const ownFollowingIds =
    currentUser?.id?.uuid && currentUser.id.uuid === user?.id?.uuid
      ? currentUser.attributes.profile.privateData?.followingIds
      : null;
  const userFollowings = Array.isArray(ownFollowingIds) ? ownFollowingIds.length : null;

  const userTier = getUserTier(userPoints);

  return (
    <div className={classNames(css.sectionContent, css.sectionInfo)}>
      <div className={css.infoBadgesWrapper}>
        {userTier ? (
          <h2 className={css.infoBadgesTierHeading}>{capitalizeFirstLetter(userTier.id)}</h2>
        ) : null}
        <Badges className={css.infoBadges} user={user} />
      </div>
      <div className={css.infoItems}>
        {infoItem(
          intl.formatMessage({
            id: 'ProfilePage.infoPoints',
          }),
          userPoints
        )}
        {!isBetaMode && infoItem(
          intl.formatMessage({
            id: 'ProfilePage.infoReviews',
          }),
          userReviews.length
        )}
        {!isBetaMode && infoItem(
          intl.formatMessage({
            id: 'ProfilePage.infoComments',
          }),
          userComments.length
        )}
        {!isBetaMode && infoItem(
          intl.formatMessage({
            id: 'ProfilePage.infoSubscriptions',
          }),
          userSubscriptions
        )}
        {!isBetaMode && userFollowings !== null && infoItem(
          intl.formatMessage({
            id: 'ProfilePage.infoFollowings',
          }),
          userFollowings
        )}
      </div>
    </div>
  );
};

export default SectionInfo;
